import { createRootRoute, Link, Outlet } from '@tanstack/react-router';
import { z } from 'zod';
export const Route = createRootRoute({
  validateSearch: z.object({ returnTo: z.string().optional(), oauthQuery: z.string().optional() }).parse,
  component: Outlet,
  notFoundComponent: () => (
    <main className="px-6 py-17.5 grid justify-items-center gap-4 text-center text-kumo-subtle [&_h2]:m-0 [&_h2]:text-[20px] [&_h2]:font-semibold [&_h2]:tracking-[-0.35px] [&_h2]:text-kumo-brand [&_p]:m-0 [&_p]:leading-[1.65] [&_p]:text-[13px]">
      <h1 className="text-[30px] leading-[1.2] font-semibold tracking-[-0.8px]">Page not found</h1>
      <Link to="/">Back to chats</Link>
    </main>
  ),
});
